import type { ReactNode } from 'react'

import { ModalFrame, type ModalSize } from '@krp/ui-kit'

import { SaleLinkStrip } from './SaleLink'

/**
 * Диалог поверх РМК (план UI-IA 5.5): возвращает значение вызывающему —
 * «Отложенные чеки», «Очистить чек?», ход оплаты, «☰ Каталог» — и адреса не
 * имеет: воскрешать по F5 диалог, чей колбэк умер вместе со страницей, нельзя
 * (CLAUDE.md §7). Рамка — `ModalFrame` ui-kit: Esc и крестик закрывают, щелчок
 * мимо — нет (в окне идёт работа). Сверху — строка связи с сервером (RP-SALE-FAST, шаг 5): общее окно связи поверх диалога не
 * рисуется, чтобы не перекрыть его кнопки; в норме строки нет. `watchAge` — диалог ждёт опроса (ход оплаты).
 */
export function RmkDialog({
  title,
  size = 'md',
  onClose,
  children,
  container,
  watchAge = false,
}: {
  title: string
  size?: ModalSize
  onClose?: () => void
  container?: HTMLElement
  watchAge?: boolean
  children: ReactNode
}) {
  return (
    <ModalFrame title={title} size={size} covered={false} onClose={onClose} container={container}>
      <SaleLinkStrip watchAge={watchAge} className="rmk-link--dialog" />
      {children}
    </ModalFrame>
  )
}
